<template>
    <div class="pack-page">
        <gameInfoTitle title="背包資訊"></gameInfoTitle>
        <div class="pack-detail">
            <baseInfoWrap titleColor="#d2d5da" :useBorder="false" textColor="#e7e9eb" title="BEI BAO XIN XI">
                <table class="pack-table">
                    <colgroup>
                        <col style="width: 1.5rem">
                        <col style="width: 1rem">
                        <col style="width: 3.5rem">
                    </colgroup>
                    <tr>
                        <td class="pack-table-cell pack-table-cell1" :rowspan="rowSpanCount">
                            <div class="icon-wrap">
                                <gameObjCard :type="3" :hasName="false" :src="detailData.liveSrc"
                                    :quality="detailData.packQuality">
                                </gameObjCard>
                            </div>
                        </td>
                        <td class="pack-table-cell pack-table-cell2" colspan="2">
                            <div class="text-wrap">
                                <div class="text-cell">
                                    <p class="text-cell1">名稱:</p>
                                    <p class="text-cell2">{{ detailData.packName }}</p>
                                </div>
                                <div class="text-cell" v-if="detailData.repair">
                                    <p class="text-cell1">修理量:</p>
                                    <p class="text-cell2">{{ detailData.repair }}</p>
                                </div>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td class="pack-table-cell pack-table-cell3" colspan="2">
                            <div class="text-wrap">
                                <div class="text-cell">
                                    <p class="text-cell1">品質:</p>
                                    <p class="text-cell2">{{ detailData.packQuality | filterQulity }}</p>
                                </div>
                                <div class="text-cell">
                                    <p class="text-cell1">重量:</p>
                                    <p class="text-cell2">{{ detailData.packWeight }}</p>
                                </div>
                            </div>
                        </td>
                    </tr>
                    <template v-for="(item, index) in skillData">
                        <tr>
                            <td class="pack-table-cell" :class="`pack-table-cell${4 + index * 2}`" rowspan="2">
                                <div class="icon-wrap">
                                    <img :src="item.skillIcon" />
                                </div>
                            </td>
                            <td class="pack-table-cell " :class="`pack-table-cell${5 + index * 2}`">
                                <div class="text-wrap">
                                    <div class="text-cell">
                                        <p class="text-cell1">被動技能</p>
                                    </div>
                                    <div class="text-cell">
                                        <p class="text-cell1">消耗:</p>
                                        <p class="text-cell2">{{ item.skillExpend }}</p>
                                    </div>
                                    <div class="text-cell">
                                        <p class="text-cell1">冷卻:</p>
                                        <p class="text-cell2">{{ item.skillCd }}</p>
                                    </div>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td class="pack-table-cell" :class="`pack-table-cell${6 + index * 2}`">
                                <div class="text-wrap">
                                    <div class="text-cell3">
                                        <p>{{ item.skillName }}</p>
                                    </div>
                                    <div class="text-cell2">
                                        <p v-html="item.skillDesc"></p>
                                    </div>
                                </div>
                            </td>
                        </tr>
                    </template>
                </table>
            </baseInfoWrap>
        </div>
        <div class="pack-desc">
            <div class="pack-desc-grid">
                <div class="pack-desc-grid-cell1">
                    <p>獲取方式</p>
                </div>
                <div class="pack-desc-grid-cell2">
                    <p>{{ detailData.gain || '-' }}</p>
                </div>
                <div class="pack-desc-grid-cell3">
                    <p>相關描述</p>
                </div>
                <div class="pack-desc-grid-cell4">
                    <p>{{ detailData.desc || '-' }}</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import gameInfoTitle from '../components/gameInfoTitle.vue';
import baseInfoWrap from '../components/base/baseInfoWrap.vue';
import gameObjCard from '../components/base/gameObjCard.vue';
export default {
    components: { gameInfoTitle, gameObjCard, baseInfoWrap },
    props: {
        detailData: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
        }
    },
    filters: {
        filterQulity(value) {
            switch (value) {
                case 'SSSR':
                    return 'SS'
                case 'UR':
                    return 'S+'
                case 'SSR':
                    return 'S'
                case 'SR':
                    return 'A'
                case 'R':
                    return 'B'
                case 'C':
                    return 'C'
            }
        }
    },
    computed: {
        skillData() {
            if (this.detailData.skill && this.detailData.skill.length > 0) {
                return this.detailData.skill
            }
            return []
        },
        doubleSkill() {
            return this.detailData.skill ? this.detailData.skill.length > 1 ? true : false : false;
        },
        rowSpanCount() {
            let extraCount = 0;
            if (this.detailData.skill && this.detailData.skill.length > 0) {
                extraCount = this.detailData.skill.length * 2
            }
            return 3 + extraCount
        }
    },
}
</script>

<style lang="scss" scoped>
.pack-page {

    .pack-detail {
        margin-top: .12rem;
        position: relative;
        margin-bottom: .5rem;

        .pack-table {
            border-collapse: collapse;
            border-spacing: 0;
            table-layout: fixed;
            width: 100%;
            height: 100%;

            .pack-table-cell {
                border-color: #d2d5da;
                border-style: solid;
                border-width: 1px;
            }

            .icon-wrap,
            .text-wrap {
                display: flex;
                align-items: center;
                justify-content: center;
            }

            .text-wrap {
                .text-cell {
                    flex: 1;
                    padding: 0 .1rem;
                    display: flex;
                    font-size: .24rem;
                    align-items: center;
                    justify-content: center;
                    line-height: .3rem;
                }

                .text-cell1 {
                    font-weight: 600;
                    margin-right: .2rem;
                    padding: .1rem 0;
                    font-size: .24rem;
                    word-break: keep-all;
                }

                .text-cell3 {
                    font-weight: 600;
                    padding: .1rem 0;
                    font-size: .24rem;
                    word-break: keep-all;
                }

                .text-cell2 {
                    padding: .1rem;
                    flex: 1;
                    font-size: .22rem;
                    color: #404040;
                }
            }

            .icon-wrap {
                img {
                    padding: .2rem;
                    width: 1.06rem;
                    height: 1.06rem;
                    object-fit: contain;
                }
            }

            .pack-table-cell2,
            .pack-table-cell3,
            .pack-table-cell5,
            .pack-table-cell7 {
                height: .3rem;
            }

            .pack-table-cell6,
            .pack-table-cell8 {

                height: 1.3rem;

                .text-cell1,
                .text-cell3 {
                    padding: 0 .2rem;
                }
            }
        }
    }

    .pack-desc {
        width: 100%;

        .pack-desc-grid {
            display: grid;
            height: 2.3rem;
            border: .01rem solid #d2d5da;
            grid-template-rows: repeat(5, 1fr);
            grid-template-areas: "cell1"
                "cell2"
                "cell3"
                "cell4"
                "cell4";

            &-cell1 {
                display: flex;
                align-items: center;
                justify-content: center;
                grid-area: cell1;
                background-color: #d2d5da;

                p {
                    font-size: .24rem;
                    font-weight: bold;
                }
            }

            &-cell2 {
                grid-area: cell2;
                display: flex;
                align-items: center;
                justify-content: center;

                p {
                    color: #404040;
                    font-size: .22rem;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    word-break: break-word;
                    display: -webkit-box;
                    -webkit-line-clamp: 1;
                    -webkit-box-orient: vertical;
                }

                background-color: white;

            }

            &-cell3 {
                display: flex;
                align-items: center;
                justify-content: center;

                p {
                    font-weight: bold;
                    font-size: .24rem;
                }

                grid-area: cell3;
                background-color: #d2d5da;
            }

            &-cell4 {
                p {
                    color: #404040;
                    font-size: .22rem;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    word-break: break-word;
                    display: -webkit-box;
                    -webkit-line-clamp: 2;
                    -webkit-box-orient: vertical;
                }

                display: flex;
                align-items:center;
                justify-content:center;
                grid-area: cell4;
                background-color: white;

            }
        }
    }
}
</style>